// api
import axioApi from 'api/root.api';

// 上傳模型背景圖（後端 3.11）。成功時 bgImage 換成新圖、舊圖刪除；顯示與否由 updateModel 的 bgImageSwitch 控制。
// header 用單次請求的設定，不改 axios 共用預設值（setHeader），避免影響之後的其他呼叫
export const uploadBackground = async (file, token, projectId, modelId) => {
    const urlEnd = `/editor/project/v1/${projectId}/${modelId}/uploadBackground`;
    const body = new FormData();
    body.append('file', file);
    const response = await axioApi.post(urlEnd, body, {
        headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
};
